import {Component, Inject} from '@angular/core';
import {Assessment, TaskDecision, VolunteerTaskService} from "../../../services/volunteer-task.service";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import {firstValueFrom} from "rxjs";
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-make-volunteer-task-adjustment',
    templateUrl: './make-volunteer-task-adjustment.component.html',
    styleUrls: ['./make-volunteer-task-adjustment.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, FormsModule, NgIf, FaIconComponent, MatOptionModule, MatInputModule, MatButtonModule]
})
export class MakeVolunteerTaskAdjustmentComponent {

  decision: TaskDecision | null = null;
  assessment: Assessment | 'NONE' = 'NONE' ;
  explanation: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: {
      taskId: string,
      userId: string,
      decision: TaskDecision,
      assessment: Assessment,
      explanation: string,
    },
    private $tasks: VolunteerTaskService,
    private dialogRef: MatDialogRef<MakeVolunteerTaskAdjustmentComponent>,
  ) {

    this.decision = this.data.decision ;
    if (this.data.assessment) {
      this.assessment = this.data.assessment ;
    }
    this.explanation = this.data.explanation ;
  }

  get canConfirm(): boolean {

    if (!this.explanation || this.explanation.length < 10)
      return false ;

    return true ;
  }

  async confirm() {

    if (this.decision != "OPT_IN"){
      this.assessment = "NONE" ;
    }

    const assessment: Assessment | null = (this.assessment == 'NONE') ? null : this.assessment ;

    const response = await firstValueFrom(this.$tasks.makeAdjustment(this.data.taskId, this.data.userId, this.decision, assessment, this.explanation));
    console.log(response);
    this.dialogRef.close(response) ;
  }

}
